<template>
  <b-card
    :title="device.name"
  >
    <div class="ml-2">
      <h1>
        <font>
          {{ device.value }}
        </font>
        <small>
          <font class="text-unit">{{ device.unit }}</font>
        </small>
      </h1>
    </div>
    <div :class="`device-flag ${device.color_class}`">
&nbsp;
    </div>
  </b-card>
</template>
<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'DeviceCard',
  components: { BCard },
  props: {
    device: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style scoped>
.text-unit {
  font-size: 16px;
}
</style>
